module.exports = __webpack_public_path__ + "static/media/bgQuickpass.79e85f60.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/assets/bgQuickpass.png
// module id = 1287
// module chunks = 0